import React from 'react';
export const SkeletonHeading = () => {
    return (<div className="my-5 sm:my-10 rounded mb-5 w-2/3 h-6 sm:h-8 bg-gray-400"></div>)
}